import BigNumber from 'bignumber.js';

import config from 'configs/app';

// [Basis MVP-NATIVE-1] The unit ladder is the chain's, not Ethereum's.
//
// Upstream hardcodes Ethereum's: one coin is 1e18 base units ("wei"), with an
// intermediate tier ("gwei") nine orders above the base. Basis has 9 decimals
// -- 1 LITHOS = 1e9 tomos -- so dividing a tomo amount by 1e18 understates it
// by nine orders of magnitude, and the intermediate tier does not exist at all:
// "one Gtomo" would be 1e9 tomos, which is simply one LITHOS. A gas price of
// 100 tomos was rendering as "0.0000001 Gtomo".
//
// Both are fixed here rather than at the call sites, so every consumer --
// getValueWithUnit, gas price, base fee, block reward, coin-balance history --
// inherits one definition that cannot drift from the balances, since it reads
// the same decimals the currency display uses.
//
// COIN_DECIMALS is the coin's precision; INTERMEDIATE_EXP is where the middle
// unit sits above the base one. Ethereum's ladder (18, 9) is reproduced
// exactly; a chain with 9 or fewer decimals has no room for a middle unit, so
// the tier collapses onto the base unit itself (exponent 0) and gas prices read
// in whole tomos.
const COIN_DECIMALS = config.chain.currency.decimals;
const INTERMEDIATE_EXP = COIN_DECIMALS > 9 ? 9 : 0;

/** Base units in one coin: 1e18 wei on Ethereum, 1e9 tomos on Basis. */
export const WEI = new BigNumber(10).pow(COIN_DECIMALS);
/** Base units in one intermediate unit: 1e9 on Ethereum, 1 on Basis. */
export const GWEI = new BigNumber(10).pow(INTERMEDIATE_EXP);
export const WEI_IN_GWEI = GWEI;
export const ZERO = new BigNumber(0);

export const SECOND = 1_000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;
export const WEEK = 7 * DAY;
export const MONTH = 30 * DAY;
export const YEAR = 365 * DAY;

export const Kb = 1_000;
export const Mb = 1_000 * Kb;

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
